import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type {
  ListTransactionsParams,
  TransactionItem,
  TransactionPagination,
  UserTransactionSummary,
} from '@/types/transactions';

class UserTransactionService {
  list(params: ListTransactionsParams = {}) {
    return apiClient.get<
      ApiResponse<{ transactions: TransactionItem[]; pagination: TransactionPagination }>
    >('/users/transactions', { params: params as Record<string, string | number> });
  }

  recent(limit = 5) {
    return apiClient.get<ApiResponse<{ transactions: TransactionItem[] }>>('/users/transactions/recent', {
      params: { limit },
    });
  }

  summary() {
    return apiClient.get<ApiResponse<{ summary: UserTransactionSummary }>>('/users/transactions/summary');
  }

  getByReference(reference: string) {
    return apiClient.get<ApiResponse<{ transaction: TransactionItem }>>(
      `/users/transactions/${encodeURIComponent(reference)}`,
    );
  }
}

export const userTransactionService = new UserTransactionService();
